export const GET_CONTENT = 'GET_CONTENT';
